import React from 'react';
import { Button } from './ui/Button';
import { CheckCircle2, ShieldCheck, CreditCard } from 'lucide-react';
import { Card } from './ui/Card';
export function CheckoutSection() {
  const checkoutUrl = 'https://checkout.digitalpack.shop/cart/43448261443662:1';
  return <section className="py-20 bg-gray-50" id="comprar" data-id="element-25">
      <div className="container mx-auto px-4" data-id="element-26">
        <div className="max-w-5xl mx-auto" data-id="element-27">
          <Card className="overflow-hidden shadow-2xl border-0 ring-1 ring-gray-200" data-id="element-28">
            <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-29">
              {/* Product Image Side */}
              <div className="relative h-64 md:h-auto bg-gray-100" data-id="element-30">
                <img src="https://cdn.magicpatterns.com/uploads/p5PzU77hodURvQ2BLeNHCk/ChatGPT_Image_15_feb_2026,_09_53_29_p.m..png" alt="Mega Pack de Teatro - Edición Completa" className="w-full h-full object-cover" data-id="element-31" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-6 md:hidden" data-id="element-32">
                  <span className="bg-red-600 text-white px-3 py-1 rounded-full text-sm font-bold shadow-lg" data-id="element-33">
                    Oferta Especial
                  </span>
                </div>
              </div>

              {/* Pricing & CTA Side */}
              <div className="p-8 md:p-12 flex flex-col justify-center bg-white" data-id="element-34">
                <div className="mb-6" data-id="element-35">
                  <div className="flex items-center gap-3 mb-2" data-id="element-36">
                    <span className="bg-red-100 text-red-700 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide" data-id="element-37">
                      Oferta Limitada
                    </span>
                    <span className="text-green-600 text-sm font-bold flex items-center gap-1" data-id="element-38">
                      <ShieldCheck className="w-4 h-4" data-id="element-39" /> Garantía de
                      Satisfacción
                    </span>
                  </div>

                  <h2 className="text-3xl font-serif font-bold text-gray-900 mb-2" data-id="element-40">
                    Mega Pack de Teatro
                  </h2>
                  <p className="text-gray-500 mb-6" data-id="element-41">
                    Acceso inmediato a todos los recursos, planificaciones y
                    bonos exclusivos.
                  </p>

                  <div className="flex items-end gap-4 mb-8" data-id="element-42">
                    <div className="flex flex-col" data-id="element-43">
                      <span className="text-gray-400 text-lg line-through font-medium" data-id="element-44">
                        $47.900
                      </span>
                      <span className="text-5xl font-bold text-gray-900 tracking-tight" data-id="element-45">
                        $19.990
                      </span>
                    </div>
                    <span className="mb-2 bg-green-100 text-green-700 px-2 py-1 rounded text-sm font-bold" data-id="element-46">
                      -58% OFF
                    </span>
                  </div>

                  <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-47">
                    <Button size="lg" variant="primary" className="w-full text-lg py-6 shadow-red-200 hover:shadow-red-300 transform transition-all hover:-translate-y-1" data-id="element-48">
                      Adquirir el Pack
                    </Button>
                  </a>

                  <p className="text-center text-xs text-gray-400 mt-3 flex items-center justify-center gap-2" data-id="element-49">
                    <img src="https://http2.mlstatic.com/frontend-assets/mp-web-navigation/ui-navigation/6.6.92/mercadopago/logo__large@2x.png" alt="Mercado Pago" className="h-5" data-id="element-50" />
                    Pago seguro con Mercado Pago
                  </p>
                </div>

                <div className="border-t border-gray-100 pt-6" data-id="element-51">
                  <h4 className="text-sm font-bold text-gray-900 mb-3 uppercase tracking-wide" data-id="element-52">
                    Lo que recibís hoy:
                  </h4>
                  <ul className="space-y-2" data-id="element-53">
                    {['Planificaciones Primaria y Secundaria', 'Banco de Dinámicas Grupales', 'Proyectos de Montaje Completos', 'Kit de Guiones Editables', 'Acceso de por vida a las actualizaciones'].map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-600" data-id="element-54">
                        <CheckCircle2 className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" data-id="element-55" />
                        {item}
                      </li>)}
                  </ul>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}